"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTextStyle = exports.createFontStyles = exports.getFontFromAppearance = exports.headAppearanceList = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("../helpers");
const breakpoint_1 = require("../helpers/breakpoint");
const typing_1 = require("./typing");
const lodash_1 = __importDefault(require("lodash"));
//Typing helpers
exports.headAppearanceList = [
    components_core_1.TokenTextAppearance.headline600,
    components_core_1.TokenTextAppearance.headline500,
    components_core_1.TokenTextAppearance.headline400,
    components_core_1.TokenTextAppearance.headline300,
    components_core_1.TokenTextAppearance.headline200,
    components_core_1.TokenTextAppearance.headline600,
    components_core_1.TokenTextAppearance.headline500,
    components_core_1.TokenTextAppearance.headline400,
    components_core_1.TokenTextAppearance.headline300,
    components_core_1.TokenTextAppearance.headline200
];
/**
 * Get color by setting or default
 * @param color TextColor
 * @param theme ThemeDefinition
 */
const getColor = (color, theme) => {
    switch (color) {
        case components_core_1.TokenTextColor.inherit:
            return 'inherit';
        case components_core_1.TokenTextColor.primary:
            return theme.colors.content.primary;
        case components_core_1.TokenTextColor.secondary:
            return theme.colors.content.secondary;
        default:
            return 'inherit';
    }
};
/**
 * Get Font Weight default and custom
 * @param fontWeight TextWeight
 * @param theme ThemeDefinition by Context
 * @param appearance General Text Appearence
 */
const getFontWeight = (fontWeight, appearance) => {
    switch (fontWeight) {
        case typing_1.TextWeight.bold:
            return 'bold';
        case typing_1.TextWeight.regular:
            return 'regular';
        case typing_1.TextWeight.light:
            return 'light';
        default:
            return appearance && exports.headAppearanceList.indexOf(appearance) > -1
                ? 'light'
                : 'regular';
    }
};
/**
 * Get text only if element field exits
 * @param style TextStyle
 * @param breakpoint String
 * @param appearance General Text Appearence
 * @param theme ThemeDefinition from context
 */
function getTextCssByBreakpoint(style, breakpoint, appearance, theme) {
    if (breakpoint === '0') {
        return getTextDefaultStyle(appearance, theme, style);
    }
    const { fontType, fontSize, fontWeight, color, textAlign, lineHeight } = style;
    return `
    ${fontType
        ? `font-family: ${theme.fonts[fontType][100].fontFamily};`
        : ''}
    ${fontSize ? `font-size: ${fontSize}px;` : ''}
    ${lineHeight || fontSize
        ? `line-height: ${lineHeightCalculation(lineHeight, fontSize, fontType, appearance, theme)};`
        : ''}
    ${fontWeight
        ? `font-weight: ${getFontWeight(fontWeight, appearance)};`
        : ''}
    ${color ? `color: ${getColor(color, theme)};` : ''}
    ${textAlign ? `text-align: ${textAlign};` : ''}
    ${fontSize
        ? `letter-spacing: ${letterSpacingCalculation(fontSize)};`
        : ''}
  `;
}
/**
 * Get Default Breakpoint style, using custom or default style.
 * @param appearance TextAppearence
 * @param theme ThemeDefinition from context
 * @param style TextStyle
 */
const getTextDefaultStyle = (appearance, theme, style) => {
    const { fontType, fontSize } = (0, exports.getFontFromAppearance)(appearance);
    return `line-height: ${lineHeightCalculation(style === null || style === void 0 ? void 0 : style.lineHeight, style === null || style === void 0 ? void 0 : style.fontSize, style === null || style === void 0 ? void 0 : style.fontType, appearance, theme)};
  font-size: ${style && style.fontSize
        ? style.fontSize + 'px'
        : theme.fonts[fontType][fontSize].fontSize};
  letter-spacing: ${style && style.fontSize
        ? letterSpacingCalculation(style.fontSize || 12)
        : theme.fonts[fontType][fontSize].letterSpacing};
  font-family: ${style && style.fontType
        ? theme.fonts[style.fontType][100].fontFamily
        : theme.fonts[fontType][fontSize].fontFamily};
  color: ${getColor(style === null || style === void 0 ? void 0 : style.color, theme)};
  text-align: ${style && style.textAlign ? style.textAlign : components_core_1.TextAlignment.left};
  font-weight: ${getFontWeight(style === null || style === void 0 ? void 0 : style.fontWeight, appearance)};
`;
};
/**
 * Get letterspacing calculation usinf font size
 * @param fontSize TextSize
 */
const letterSpacingCalculation = (fontSize) => {
    const baseFontSize = 16;
    const letterSpacingFactor = -0.35;
    return `${((fontSize / baseFontSize - 1) * letterSpacingFactor).toFixed(2)}px`;
};
const getFontFromAppearance = (appearance) => {
    const fontType = appearance.includes("head") ? "headline" : appearance.includes("copy") ? "copy" : "label";
    const fontSize = Number.parseInt(appearance.slice(appearance.length - 3, appearance.length));
    if (!Number.isNaN(fontSize)) {
        return { fontType, fontSize };
    }
    else {
        return { fontType, fontSize: 100 };
    }
};
exports.getFontFromAppearance = getFontFromAppearance;
/**
 * Get Line height calculation using font size anf type, or use custom value
 * @param lineHeight TextLineHeight
 * @param fontSize TextSize
 * @param fontType TextType
 * @param textAppearance TextAppearence
 * @param theme ThemeDefinition
 */
const lineHeightCalculation = (lineHeight, fontSize, fontType, textAppearance, theme) => {
    const { fontType: family, fontSize: size } = (0, exports.getFontFromAppearance)(textAppearance);
    if (lineHeight)
        return lineHeight + 'px';
    if (!fontSize)
        return theme.fonts[family][size].fontSize;
    const lineHeightFactor = textAppearance.indexOf('copy') > -1 || fontType === typing_1.TextType.Copy
        ? 1.5
        : 1.1;
    return `${Math.ceil((fontSize * lineHeightFactor) / 4) * 4}px`;
};
/**
 * Create font style from default and custom values,
 * @param style TextStyle
 * @param appearance TextAppearence
 * @param theme ThemeDefinition
 * @returns css string with main style and breakpoint style
 */
function createFontStyles(style, appearance, theme) {
    const textStyle = style
        ? style
        : {
            fontWeight: typing_1.TextWeight.regular,
            fontType: typing_1.TextType.Label,
            fontSize: typing_1.TextSize.TextSize14,
            lineHeight: typing_1.TextLineHeight.TextLineHeight16,
            textAlign: components_core_1.TextAlignment.left,
            color: components_core_1.TokenTextColor.primary
        };
    if ((0, breakpoint_1.isBreakpointConfig)(textStyle)) {
        return Object.keys(textStyle)
            .sort((a, b) => (0, helpers_1.compareBreakpoints)(a, b))
            .reduce((result, breakpoint) => {
            const textStyleDescription = style[breakpoint];
            const cssStyle = getTextCssByBreakpoint(textStyleDescription, breakpoint, appearance, theme);
            return (0, breakpoint_1.mediaQueryTemplate)(breakpoint, cssStyle, result);
        }, '');
    }
    return getTextDefaultStyle(appearance, theme, style);
}
exports.createFontStyles = createFontStyles;
/**
 * Join lastest context and new style
 * @param context TextStyle | BreakpointConfigType<TextStyle>
 * @param style TextStyle | BreakpointConfigType<TextStyle>
 */
const mergeTextStyle = (context, style) => {
    const isContext = (0, breakpoint_1.isBreakpointConfig)(context);
    const isStyle = (0, breakpoint_1.isBreakpointConfig)(style);
    if ((isContext && isStyle) || (!isContext && !isStyle)) {
        let clonedContext = lodash_1.default.clone(context);
        let clonedStyle = lodash_1.default.clone(style);
        return lodash_1.default.merge(clonedContext, clonedStyle);
    }
    else {
        if (isContext) {
            return Object.assign(Object.assign({}, context), { [components_core_1.Breakpoints.default]: Object.assign(Object.assign({}, context[components_core_1.Breakpoints.default]), style) });
        }
        else {
            return Object.assign(Object.assign({}, style), { [components_core_1.Breakpoints.default]: Object.assign(Object.assign({}, style[components_core_1.Breakpoints.default]), context) });
        }
    }
};
exports.mergeTextStyle = mergeTextStyle;
